import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
//Admin
import AddAdmin from '../../views/Root/AddNewAdmin.js'
import AdminList from '../../views/Root/AdminList.js'
import UserEditScreen from '../../views/Users/UserEditScreen.js'

const CustomerUsers = () => {
  return (
    <div>
      <Routes>
        <Route
          path="/rootUsers/addAdmin"
          element={<AddAdmin />}
        />

        <Route
          path="/rootUser/:uID/editprofile"
          element={<UserEditScreen />}
        />

        <Route path="/rootUsers" element={<AdminList />} />

        <Route path="/" element={<Navigate to="/rootUsers" replace />} />
      </Routes>
    </div>
  )
}
//<Container fluid>
export default CustomerUsers
